import { ThemeProvider as NextThemeProvider, useTheme } from "next-themes";
import type { ReactNode } from "react";

/** 与 index.html 里防闪屏脚本共用同一个 key，改动要两边一起改。 */
export const THEME_STORAGE_KEY = "tickbird.theme-mode";

/**
 * 主题模式边界。shadcn 的暗色靠根节点上的 `.dark` class 生效
 * （见 src/global.css 的 `@custom-variant dark`），这里用 next-themes
 * 负责 class 切换、localStorage 持久化与跟随系统。
 *
 * 首屏由 index.html 的内联脚本先把 class 打上，避免刷新时闪白。
 */
export function ThemeProvider({ children }: { children: ReactNode }) {
  return (
    <NextThemeProvider attribute="class" defaultTheme="system" enableSystem disableTransitionOnChange storageKey={THEME_STORAGE_KEY}>
      {children}
    </NextThemeProvider>
  );
}

export { useTheme };
